import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import LINK from 'constants/link.const';
import MENU_READER_STATUS from 'constants/pos/menuReaderStatus.const';
import STRIPE_STATUS from 'constants/pos/stripeStatus.const';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCalendarMode, selectCurrentSalonId, selectCurrentSalonReaderStatus, selectCurrentSalonStripeStatus } from 'selectors/currentSalon.selectors';
import linkTo from 'utils/links/linkTo.util';

import payIcon from '../../assets/images/menu/pay-card.svg';

import CN from './SlickPayLink.module.scss';

const SlickPayLink = ({ salonId, readerStatus, calendarMode, closeMenu, stripeStatus }) => {
  const { t } = useTranslation();

  return (
    <NavLink
      to={linkTo({
        pattern: LINK.slickPay,
        params: { id: salonId },
        fault: '#',
      })}
      activeClassName="active"
      className={cn(CN.link, CN[calendarMode])}
      onClick={closeMenu}
      data-bem="SlickPayLink"
    >
      <img src={payIcon} alt="" className={CN.menuIcon} />
      {readerStatus === MENU_READER_STATUS.ordered && (
        <>
          {t('composite.sidebarMenu.slickPayLink.label1')}
          {stripeStatus === STRIPE_STATUS.complete ? (
            <span className={CN.banner}>{t('composite.sidebarMenu.slickPayLink.connectBanner')}</span>
          ) : (
            <span className={cn(CN.banner, CN.warning)}>{t('composite.sidebarMenu.slickPayLink.actionRequiredBanner')}</span>
          )}
        </>
      )}

      {(readerStatus === MENU_READER_STATUS.active || readerStatus === MENU_READER_STATUS.deleted) && (
        <>
          {t('composite.sidebarMenu.slickPayLink.label2.part1')}
          <span className={CN.underline}>{t('composite.sidebarMenu.slickPayLink.label2.part2')}</span>
        </>
      )}

      {(!readerStatus || readerStatus === MENU_READER_STATUS.missing) && t('composite.sidebarMenu.slickPayLink.label2.part1')}
    </NavLink>
  );
};

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  readerStatus: selectCurrentSalonReaderStatus(state),
  stripeStatus: selectCurrentSalonStripeStatus(state),
  calendarMode: selectCurrentSalonCalendarMode(state),
});

// noinspection JSUnusedGlobalSymbols
export default connect(mapStateToProps)(SlickPayLink);
